import { AxiosPromise } from "axios";

import api from "../config/api-config";

export function getScheduleCalendar(
  storeId: any,
  sector: any,
  initialPeriod: any,
  endPeriod: any
): AxiosPromise {
  return api.get(
    `v1/schedules/stores/${storeId}?sector=${sector}&initialPeriod=${initialPeriod}&endPeriod=${endPeriod}`,
    {}
  );
}

export function getScheduleCalendarById(id: any): AxiosPromise {
  return api.get(`v1/schedules/${id}`, {});
}

export function getScheduleDateAvaliableById(id: any): AxiosPromise {
  return api.get(`v1/schedules/${id}/available-dates`, {});
}

export function postInventory(obj: any): AxiosPromise {
  return api.post("v1/schedules/inventories", obj, {});
}

export function confirmReSchedule(obj: any, id: any): AxiosPromise {
  return api.put("v1/schedules/" + id, obj, {});
}

export function saveReSchedulePatch(obj: any): AxiosPromise {
  return api.patch("v1/schedules/quantities", obj, {});
}

//DASHBOARD

export function getScheduleDashboardWeek(
  store: any,
  start: any,
  end: any
): AxiosPromise {
  return api.get(
    "v1/reports/stores/" +
      store +
      "/weeks?initialPeriod=" +
      start +
      "&endPeriod=" +
      end,
    {}
  );
}

export function getScheduleDashboardDay(store: any, date: any): AxiosPromise {
  return api.get("v1/reports/stores/" + store + "/days?date=" + date, {});
}

export function getScheduleDashboarExport(
  store: any,
  initDate: any,
  endDate: any,
  sector: any
): AxiosPromise {
  return api.get(
    `v1/schedules/stores/${store}/export?sector=${sector}&initialPeriod=${initDate}&endPeriod=${endDate}`,
    {}
  );
}

// API V2 - Nova implementação com POST

export function getScheduleCalendarV2(
  storeId: number,
  sector: string,
  supplierIds: number[],
  initialPeriod: string,
  endPeriod: string
): AxiosPromise {
  return api.post(`v2/schedules/stores/${storeId}`, {
    storeId,
    sector,
    supplierIds,
    initialPeriod,
    endPeriod,
  });
}

export function getScheduleDashboarExportV2(
  storeId: number,
  sector: string,
  supplierIds: number[],
  initialPeriod: string,
  endPeriod: string
): AxiosPromise {
  return api.post(`v2/schedules/stores/${storeId}/export`, {
    storeId,
    sector,
    supplierIds,
    initialPeriod,
    endPeriod,
  });
}

export default {
  getScheduleCalendar,
  getScheduleCalendarById,
  getScheduleDateAvaliableById,
  postInventory,
  confirmReSchedule,
  saveReSchedulePatch,
  getScheduleDashboardWeek,
  getScheduleDashboardDay,
  getScheduleDashboarExport,
  getScheduleCalendarV2,
  getScheduleDashboarExportV2,
};
